import script from "./DevicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesView.vue?vue&type=script&setup=true&lang=js"

import "./DevicesView.vue?vue&type=style&index=0&id=e4c64e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4c64e4e"]])

export default __exports__